module.exports = __webpack_public_path__ + "img/kh29.15e60c7f.png";